import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Erreur applicative :', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="bb-error">
          <h1 className="bb-display">Aïe, un pépin 🎬</h1>
          <p>Une erreur inattendue s'est produite. Recharge la page pour réessayer.</p>
          <button type="button" className="bb-btn bb-btn--primary" onClick={() => window.location.reload()}>
            Recharger
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
